// extracted by mini-css-extract-plugin
export var body = "HighlightedCruiseGroupCard-module--body--0484d";
export var card = "HighlightedCruiseGroupCard-module--card--68334";
export var image = "HighlightedCruiseGroupCard-module--image--dc88d";
export var title = "HighlightedCruiseGroupCard-module--title--7268e";